import { Auth } from '../api/amplify';

export const getAuthenticatedUser = async () => Auth.currentAuthenticatedUser();

export const getTokenFromAuthenticatedUser = (user) => user.signInUserSession?.idToken?.jwtToken;

export const getAttributesFromAuthenticatedUser = ({ attributes }) => attributes;
